import { gql } from '@apollo/client'

export const GET_ORDER_CARGO_PROFILE = gql`
  query GetOrderCargoProfile($orderNumber: String!) {
    order(number: $orderNumber) {
      id
      cargoProfiles {
        edges {
          node {
            id
            code
            customerDisplayName
            saleDisplayName
          }
        }
      }
    }
  }
`
